export default {
  saveSelectedMicroApp({ commit }, payload) {
    commit("saveSelectedMicroApp", payload)
  }
}